/* Swym Product Page button */

const swymObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList && node.classList.contains("swym-button-bar")) {
          const productGallery = document.querySelector(
            '.product product-gallery'
          );
          if (productGallery) {
            productGallery.appendChild(node);
            node.classList.add("loaded");
            swymObserver.disconnect();
          }
        }
      }
    });
  });
});

swymObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

/* Swym Product Page button */

/* Global function for SearchSpring / Add to cart + drawer update */

// Utility to detect the dynamic Stretch section IDs for the cart
function getCartSectionIds() {
  const sections = [];
  document.querySelectorAll('[id^="shopify-section-"]').forEach(sec => {
    const id = sec.id.replace('shopify-section-', '');
    if (id.includes('cart-drawer') || id.includes('cart-icon-bubble')) {
      sections.push(id);
    }
  });
  return sections;
}

// Global function for Searchspring / custom triggers
window.addToCart = async function(variantId, quantity = 1) {
  try {
    const sections = getCartSectionIds();

    // Add item to cart
    const addResp = await fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const addData = await addResp.json();

    // Fetch full cart for item_count and totals
    const cart = await fetch('/cart.js').then(r => r.json());

    // Build cartContent like Stretch theme expects
    const cartContent = { sections: addData.sections, cart };

    // Prepare items array like theme
    const items = addData.hasOwnProperty("items") ? addData.items : [addData];

    // Dispatch variant:add event for internal theme listeners
    document.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: { items, cart: cartContent }
    }));

    // Dispatch cart:change event for drawer, badge, etc.
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "variant:add", cart: cartContent }
    }));

    // Safely open the cart drawer by triggering the toggle button
    const cartButton = document.querySelector('[data-action="toggle-cart"]');
    if (cartButton) cartButton.click();

  } catch (err) {
    console.error("addToCart error:", err);

    // Dispatch cart:error for theme listeners
    document.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: { error: err.message }
    }));

    // Trigger cart:refresh as fallback
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
};

/* End of Global function for SearchSpring / Add to cart + drawer update */
